import { MessageDirection } from "@redotech/redo-marketing-common/message/marketing-message-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getMarketingConversationMessages = {
  name: "getMarketingConversationMessages" as const,
  input: z.object({
    conversationId: zExt.objectId(),
    limit: z.number().int().positive().max(1000).default(1000),
    lastSentAt: z.date().optional(),
    lastId: zExt.objectId().optional(),
  }),
  output: z.object({
    messages: z.array(
      z.object({
        _id: z.string(),
        content: z.string(),
        direction: createEnum(MessageDirection),
        sentAt: z.date().nullable(),
        createdAt: z.date(),
      }),
    ),
    hasMore: z.boolean(),
    customerName: z.string().optional(),
    customerPhone: z.string().optional(),
    customerEmail: z.string().optional(),
    totalConversations: z.number(),
    totalRevenue: z.number(),
    orders: z.array(
      z.object({
        _id: z.string(),
        orderName: z.string(),
        totalPrice: z.number(),
        timestamp: z.date(),
        attributedToRecover: z.boolean(),
      }),
    ),
    checkoutEvents: z.array(
      z.object({
        _id: z.string(),
        totalPrice: z.number().nullable(),
        itemCount: z.number(),
        timestamp: z.date(),
      }),
    ),
  }),
};
